// MUI theme for the Catering pages ONLY (Catering.jsx for a restaurant,
// SuperAdminCatering.jsx for the super admin, and their tier editor).
//
// It is the Delivery page theme (ink primary, amber notes, orange focus ring,
// labels above 48px fields, input adornments, radios, 44px chips) plus the
// 44x26 switch the Promotions pages use. Catering's own purple (CATERING in
// utils/catering.js) marks catering things only — the cloche, the chips — never
// buttons or fields.
import { createTheme } from '@mui/material/styles'
import { deliveryZonesTheme, DZ, focusRing } from './deliveryZonesTheme'
import { CATERING } from '../utils/catering'

export const CT = {
  ...DZ,
  accent: CATERING.accent,
  accentSoft: CATERING.soft,
  accentBorder: CATERING.border,
  rowBorder: '#EEF0F3',
  headBg: '#F6F7F9',
  onBg: '#ECFDF3',
  onText: '#067647',
  onBorder: '#ABEFC6'
}

export { focusRing }

const extra = () => ({
  MuiSwitch: {
    styleOverrides: {
      // 44x26 track, 20px knob. Everything sits under root so it beats the
      // default size styles.
      root: {
        width: 44,
        height: 26,
        padding: 0,
        overflow: 'visible',
        flexShrink: 0,
        '& .MuiSwitch-switchBase': { padding: 3, color: '#FFFFFF', '&:hover': { backgroundColor: 'transparent' } },
        '& .MuiSwitch-switchBase.Mui-checked': { transform: 'translateX(18px)', color: '#FFFFFF', '&:hover': { backgroundColor: 'transparent' } },
        '& .MuiSwitch-thumb': { width: 20, height: 20, boxShadow: '0 1px 2px rgba(16, 24, 40, 0.24)' },
        '& .MuiSwitch-track': { borderRadius: 13, backgroundColor: DZ.inputBorder, opacity: 1, transition: 'background-color 150ms ease' },
        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: DZ.text, opacity: 1 },
        '& .MuiSwitch-switchBase.Mui-disabled + .MuiSwitch-track': { opacity: 0.45 },
        '& .MuiSwitch-switchBase.Mui-focusVisible + .MuiSwitch-track': focusRing
      }
    }
  }
})

export const cateringTheme = outer => {
  const base = deliveryZonesTheme(outer)
  return createTheme({ ...base, components: { ...base.components, ...extra() } })
}
